<template>
  <div class="px-4">
    <v-form>
      <validation-provider v-slot="{ errors }" name="Loại hình" rules="required">
        <v-autocomplete
          v-model="dataForm.typeId"
          :items="types"
          item-text="name"
          item-value="id"
          label="Loại hình *"
          :error-messages="errors"
          clearable
          eager
          @change="selectContactStatusList(), onChangeSelectType()"
        />
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Nhóm ngành" rules="required">
        <v-autocomplete
          v-model="dataForm.schoolLevelId"
          :items="listSchoolLevelByType"
          item-text="name"
          item-value="id"
          label="Nhóm ngành *"
          :error-messages="errors"
          clearable
          :disabled="!dataForm.typeId"
          :filled="!dataForm.typeId"
          eager
          @change="selectContactStatusList()"
        />
      </validation-provider>
      <validation-provider
        v-if="dataForm.isDetail"
        v-slot="{ errors }"
        name="Mối quan hệ"
        :rules="{required: checkAuthorization('contact_change_status_read')}"
      >
      <v-autocomplete
        :readonly="!checkAuthorization('contact_change_status_read') || !checkConditionT4NT5(_.get(dataForm, 'contactStatus.type', ''))"
        v-model="dataForm.statusId"
        :items="contactStatusList"
        item-text="otherName"
        item-value="id"
        label="Mối quan hệ"
        :error-messages="errors"
      />
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Nguồn khách hàng">
        <v-autocomplete
          v-model="dataForm.contactSourceIds"
          :items="contactSources"
          item-text="name"
          item-value="id"
          label="Nguồn khách hàng"
          :error-messages="errors"
          multiple
        />
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="Người phụ trách"
      >
        <common-select-user
          :readonly="!checkAuthorization('contact_change_user_read')"
          v-model="dataForm.userId"
          :items="getSelectUser"
          item-text="fullName"
          item-value="id"
          label="Người phụ trách"
          :error-messages="errors"
        />
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Số đơn hàng đã mua">
        <v-text-field
          :value="formatPrice(_.get(dataForm, 'order.totalOrder', 0) || 0)"
          label="Số đơn hàng đã mua"
          :error-messages="errors"
          color="primary"
          disabled
        />
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Tổng giá trị đơn hàng đã mua">
        <v-text-field
          :value="formatPrice(_.get(dataForm, 'order.totalValue', 0) || 0)"
          label="Tổng giá trị đơn hàng đã mua"
          :error-messages="errors"
          color="primary"
          disabled
        />
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Mã khách hàng">
        <v-text-field
          v-model="dataForm.code"
          label="Mã khách hàng"
          :error-messages="errors"
          color="primary"
          disabled
        />
      </validation-provider>
      <v-autocomplete
        v-model="dataForm.productGroups"
        :items="productGroups"
        item-text="name"
        item-value="id"
        label="Nhóm sản phẩm"
        color="primary"
        multiple
      />
      <validation-provider v-slot="{ errors }" name="Mã">
        <v-text-field
          v-model="dataForm.codeSource"
          label="Mã"
          :error-messages="errors"
          color="primary"
          disabled
        />
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Nhân viên marketing" rules="max:255">
        <v-text-field
          v-model="dataForm.userMarketingName"
          label="Nhân viên marketing"
          :error-messages="errors"
          color="primary"
        />
      </validation-provider>
      <!-- <validation-provider v-slot="{ errors }" name="Note" rules="max:255">
        <v-textarea
          v-model="dataForm.description"
          label="Ghi chú"
          :error-messages="errors"
          color="primary"
          rows="3"
        />
      </validation-provider> -->
      <template v-for="(contactColumn, indexContact) in contactColumnList">
        <v-text-field
          v-if="contactColumn.type === 'text'"
          :key="'indexContact_' + indexContact"
          v-model="dataForm[contactColumn.id]"
          :label="contactColumn.description"
          color="primary"
        />
        <v-textarea
          v-else-if="contactColumn.type === 'textarea'"
          :key="'indexContact_' + indexContact"
          v-model="dataForm[contactColumn.id]"
          :label="contactColumn.description"
          rows="2"
        />
      </template>
    </v-form>
  </div>
</template>

<script>
import TokenService from '../../../helpers/token';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactStatusRepository = RepositoryFactory.get('contact_status');
export default {
  props: {
    contactColumns: {
      type: Object,
      default: () => ({})
    },
    contactSources: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    productGroups: {
      type: Array,
      default: () => []
    },
    dataForm: {
      type: Object,
      default: () => {}
    },
    // contactStatusList: {
    //   type: Array,
    //   default: () => []
    // },
    schoolLevels: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      contactStatusList: []
    }
  },
  created() {
    this.selectContactStatusList()
  },
  computed: {
    listSchoolLevelByType() {
        if(this.schoolLevels.length > 0 && this.dataForm.typeId){
            const result = this.schoolLevels.find(school => school.id === this.dataForm.typeId)
            return result.schoolLevel || []
        } else return []
    },
    contactColumnList() {
      return _.get(this.contactColumns, 'contact', []) || [];
    },
    getSelectUser() {
      return this.users;
      // if (this.isManager() || this.checkAuthorization('contact_view_all')) {
      //   return this.users;
      // }
      // const dataUser = TokenService.getUser() || {};
      // const userId = _.get(dataUser, 'id', '');
      // if (this.isStaff()) {
      //   return this.users.filter(data => data.id == userId);
      // }
      // return this.users.filter(
      //   data => data.departmentId === dataUser.departmentId || dataUser.listDepartmentIds.includes(data.departmentId)
      // );
    }
  },
  methods: {
    onChangeSelectType(){
      this.dataForm.schoolLevelId = null
    },
    async selectContactStatusList() {
      console.log('this.dataForm: ', this.dataForm)
      const selectType =
          _.get(this.dataForm, 'contactStatus.type', 'T').includes('T')
              ? ['T0', 'T1', 'T2', 'T3']
              : _.get(this.dataForm, 'contactStatus.type', 'C').includes('C') ? ['C0', 'C1', 'C2', 'C3']
              : ['M0', 'M1', 'M2', 'M3', 'M4'];
      if (this.isStaff() && !this.checkAuthorization('contact_view_all')) {
        selectType.shift();
      }

      const contactStatusList = [];
      const loading = this.$loading.show();
      const response = await ContactStatusRepository.list({
        store: this.dataForm.store,
        typeId: this.dataForm.typeId,
        schoolLevelId: this.dataForm.schoolLevelId
      });
      loading.hide();
      if (response.success) {
        const checkType = {};
        _.get(response, 'data', []).forEach(contactStatus => {
          const typeContactStatus = contactStatus.type;
          const listStatusChild = _.get(contactStatus, 'data', [])
          if (
              selectType.includes(typeContactStatus.slice(-2)) ||
              (listStatusChild.findIndex(elc => elc.id == this.dataForm.statusId) > -1)
          ) {
            if (!checkType[typeContactStatus]) {
              checkType[typeContactStatus] = true;
              if (contactStatusList.length > 0) {
                contactStatusList.push({divider: true});
              }
              contactStatusList.push({
                header: typeContactStatus.slice(0, typeContactStatus.length - 4),
                style: 'color: red;'
              });
              listStatusChild.forEach(data => {
                if(selectType.includes(typeContactStatus.slice(-2)) ||
                    (data.id == this.dataForm.statusId)) {
                  data.otherName = `${typeContactStatus.slice(-2)} ${data.name}`
                  contactStatusList.push({
                    id: _.get(data, 'id', 0),
                    otherName: _.get(data, 'otherName', ''),
                    type: _.get(data, 'type', ''),
                  });
                }
              });
            }
          }
        });
      }
      this.contactStatusList = contactStatusList;
      console.log('contactStatusList: ', this.contactStatusList)
    },
  }
};
</script>
